/**
 * Seayisyen — Training Video Catalog
 *
 * Single source of truth for the Video Training Hub on `/`.
 * To add a new video, just append an object to the right category's `videos` array.
 *
 * Schema:
 *   { id: stable React key, youtubeId: 11-char id, title: localizable string,
 *     meta?: optional badge text (e.g. affiliate notice) }
 */

export const onboardingVideo = {
  youtubeId: "ebVCWvilPuM",
  title: "Aksyon Obligatwa · Kreye kont LeadMotivH",
};

export const trainingCategories = [
  {
    key: "foundations",
    icon: "shield",
    videos: [
      {
        id: "f1",
        youtubeId: "NhmuwS6N3zc",
        title: "Sa nou menm k ap itilize entènèt dwe konnen + ak atansyon nou dwe pran",
      },
      {
        id: "f2",
        youtubeId: "USIoob18WdY",
        title: "Zoom ak sos splashtop",
      },
      {
        id: "f3",
        youtubeId: "O_eTF9p-2eo",
        title: "Antivirus · sos splashtop · WhatsApp",
      },
    ],
  },
  {
    key: "domains",
    icon: "globe",
    videos: [
      {
        id: "d1",
        youtubeId: "3NSTm-fGN5I",
        title: "Poukisa li enpòtan pou gen yon sit entènèt ?",
      },
      {
        id: "d2",
        youtubeId: "K_RR36ADQz0",
        title: "Kisa non Domèn nan ye ? E kòman w ka chwazi yon non Domèn ?",
      },
      {
        id: "d3",
        youtubeId: "cJeaCz8n8Uw",
        title: "Kreye kont nou sou Namespro",
        meta: { type: "affiliate", label: "Sèvi ak lyen afilye sa a", href: "https://www.namespro.ca/" },
      },
      {
        id: "d4",
        youtubeId: "FsT3GgGZQTE",
        title: "Etap pou verifye non pou sit ou",
      },
    ],
  },
  {
    key: "wordpress",
    icon: "rocket",
    videos: [
      {
        id: "w1",
        youtubeId: "JuteiTFAmv8",
        title: "Nou demare ak kou a (Lendi 29 Juin 2026)",
      },
      {
        id: "w2",
        youtubeId: "FX9YAIAf_6I",
        title: "Gid Kreyasyon Sit Web soti A a Z (Creole Guide)",
      },
      {
        id: "w3",
        youtubeId: "IwkyLRmWDMg",
        title: "Koman kreye e valide kont YouTube ou / mete yon lyen YouTube sou paj WordPress",
      },
      {
        id: "w4",
        youtubeId: "FsT3GgGZQTE",
        // The user provided an additional query option; YouTube ignores it for embeds.
        title: "Video sou sous domèn WP Divi",
      },
      {
        id: "w5",
        youtubeId: "JXEOIgyk3eE",
        title: "Video Intro WordPress",
      },
      {
        id: "w6",
        youtubeId: "BdwYOiFTp2E",
        title: "Kòman kreye paj e menu",
      },
    ],
  },
];
